import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from './../../styles/constants';

export const useStyles = makeStyles(theme => ({
	gutterBottomTitle: {
		marginBottom: theme.spacing(3)
	},
	filter: {
		marginBottom: theme.spacing(1.5)
	},
	filterGutterBottom: {
		// chip Qualification
		marginBottom: theme.spacing(3)
	},
	filterRight: {
		display: 'flex',
		justifyContent: 'flex-end'
	},
	note: {
		marginTop: theme.spacing(2.5)
	},
	chartContainer: {
		flexGrow: 1,
		marginTop: 18,
		[theme.breakpoints.down('600')]: {
			display: 'none'
		}
	},
	webDesignerAccordion: {
		width: '1230px',
		marginTop: '5px',
		marginLeft: '20px',
		marginBottom: '15px',
		[theme.breakpoints.down('1341')]: {
			width: 'auto'
		},
		[theme.breakpoints.down('935')]: {
			width: '80vw'
		}
	},
	divider: {
		background: `${COLORS.PRIMARY} !important`,
		height: '2px !important'
	},
	accordion: {
		'&:hover': {
			color: COLORS.PRIMARY
		}
	},
	expand_icon: {
		color: COLORS.PRIMARY
	},
	shareButton: {
		color: COLORS.WHITE,
		border: `1px solid ${COLORS.SECONDARY}`,
		borderRadius: '50rem',
		fontWeight: 600,
		'&:hover': {
			color: COLORS.SECONDARY,
			background: COLORS.WHITE,
			boxShadow: 'none'
		}
	},
	handIcon: {
		height: '2rem',
		marginRight: 10
	},
	chatIcon: {
		height: '2.5rem',
		width: '2.5rem',
		color: COLORS.WHITE,
		position: 'absolute',
		right: 20,
		top: 20,
		// bottom: 50,
		display: 'flex',
		alignItems: 'center',
		justifyItems: 'center',
		backgroundColor: COLORS.PRIMARY,
		'&:hover': {
			color: COLORS.PRIMARY,
			background: COLORS.WHITE,
			boxShadow: `1px 1px 10px 1px ${COLORS.BORDER}`
		}
	},
	needgt: {
		position: 'absolute',
		right: 20,
		bottom: 10,
		display: 'flex',
		alignItems: 'center'
	},
	chatWindowSlider: {
		zIndex: 10,
		position: 'relative',
		right: 20,
		top: 20,
		display: 'flex',
		alignItems: 'center'
	},
	gateDriverMenu: {
		marginTop: '5px'
	},
	roundedMenu: {
		borderRadius: theme.shape.borderRadius
	},
	crossSell: {
		cursor: 'pointer',
		color: COLORS.LINK,
		'&:hover': {
			textDecoration: 'underline'
		}
	}
}));
